// src/components/HotelPage/ZipcodeCheckSection.jsx
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { validateZipcode } from '../../redux/slices/ZipCode/zipCodeSlice';

// Igual que ZipcodeModal.jsx pero en línea (no modal) - vive como el primer
// bloque de HotelPage y avisa al padre si el código postal sí tiene servicio,
// para que el resto de la página (precios, cuartos) se revele después.
const ZipcodeCheckSection = ({ onResult }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.zipcode);
  const [zipcode, setZipcode] = useState('');
  const [status, setStatus] = useState(null); // null | 'valid' | 'invalid'

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setZipcode(value);
    setStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (zipcode.length !== 5) return;
    try {
      const result = await dispatch(validateZipcode(zipcode)).unwrap();
      setStatus(result.valid ? 'valid' : 'invalid');
      onResult?.(result.valid);
    } catch {
      setStatus('invalid');
      onResult?.(false);
    }
  };

  return (
    <section className="bg-[#EFE6DD] py-16 sm:py-24">
      <div className="max-w-xl mx-auto px-4 text-center">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9A0002]">
          {t('hotelPage.step1')}
        </span>
        <h1 className="mt-2 font-['Fraunces'] text-3xl sm:text-4xl font-semibold text-[#3A2A20]">
          {t('hotelPage.zipTitle')}
        </h1>
        <p className="mt-3 text-[#3A2A20]/70">
          {t('hotelPage.zipSubtitle')}
        </p>

        <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <input
            type="text"
            inputMode="numeric"
            maxLength="5"
            value={zipcode}
            onChange={handleChange}
            placeholder={t('hotelPage.zipPlaceholder')}
            className="px-4 py-3 sm:w-48 border border-[#3A2A20]/15 rounded-xl text-center focus:outline-none focus:ring-2 focus:ring-[#9A0002]/40 focus:border-[#9A0002] transition"
          />
          <button
            type="submit"
            disabled={isLoading || zipcode.length !== 5}
            className="px-6 py-3 bg-[#9A0002] hover:bg-[#7A0001] text-[#EFE6DD] rounded-xl font-medium text-sm transition disabled:opacity-50"
          >
            {isLoading ? t('hotelPage.checking') : t('hotelPage.check')}
          </button>
        </form>

        <div className="h-6 mt-4">
          {status === 'valid' && (
            <p className="text-sm font-medium text-[#3A6B4C]">
              {t('hotelPage.zipValid')}
            </p>
          )}
          {status === 'invalid' && (
            <p className="text-sm font-medium text-[#9A0002]">
              {t('hotelPage.zipInvalid')}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ZipcodeCheckSection;